// Live interval of the played note against the drone.
export const IntervalPill = ({ interval, label }) => (
  <div data-testid="tuner-interval" className={`rounded-full border px-4 py-2 flex items-center gap-3 text-sm ${interval && Math.abs(interval.cents) <= 5 ? 'border-emerald-400/60 text-emerald-300 bg-emerald-400/10' : 'border-sky-400/40 text-sky-200 bg-sky-400/10'}`}>
    <span className="text-[10px] uppercase tracking-[0.25em] text-white/50">vs <span className="normal-case font-mono">{label}</span></span>
    {interval ? (
      <>
        <span data-testid="tuner-interval-name" className="font-mono font-semibold text-lg leading-none">{interval.short}</span>
        <span className="text-xs text-white/70">{interval.name}</span>
        <span data-testid="tuner-interval-cents" className="font-mono text-xs">{interval.cents > 0 ? '+' : ''}{interval.cents} cent</span>
      </>
    ) : <span className="text-xs text-white/50">Suona una nota…</span>}
  </div>
);
